import React, { useState } from 'react';
import { ScSingleSelect } from '@app/components/Base';

const listGender = [
    {
        name: 'Nam',
        value: 1,
    },
    {
        name: 'Nữ',
        value: 0,
    },
];

const GenderSelect = ({ input, type, label, ...props }) => {
    const { onChange: inputOnChange, value: inputValue } = input;
    const [gender, setGender] = useState(inputValue);

    const onChange = (e) => {
        inputOnChange(e);
        setGender(e);
    };

    return (
        <ScSingleSelect
            dataSource={listGender}
            selectId={gender}
            idField="value"
            nameField="name"
            onChange={onChange}
            {...props}
        />
    );
};

export default GenderSelect;
